import { render } from "./ProjectAlerts.vue?vue&type=template&id=2e3281e6&scoped=true"
import script from "./ProjectAlerts.vue?vue&type=script&lang=js"
export * from "./ProjectAlerts.vue?vue&type=script&lang=js"

import "./ProjectAlerts.vue?vue&type=style&index=0&id=2e3281e6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3281e6"]])

export default __exports__